module.exports = require("@embedpdf/plugin-document-manager/react");